module.exports = "/_next/static/images/DelightYourCustomers@2x-2b9ca708c077938542fde637bdecd01d.webp";